<template>
     <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="甲子订单共享与安全">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="text-content">
            <p class="text-item">您的订单信息<span>至少包括您的收货人姓名、收货地址、手机号码、订单号、商品或服务的交易信息以及您应支付的货款金额；</span>需实名登记的商品；另外您也可以填写您的固定电话、邮箱地址等其他为了确保我们的商品或服务可以准确送达的信息，但这些信息不是您订单生成和结算所必须。我们基于订单信息为您配送商品或提供服务。</p>
            <p class="text-item"><span>我们可能会向实现您购物所必须的关联方或合作伙伴共享您的订单信息，以保障为您提供的服务顺利进行。比如我们必须与物流服务提供商共享您的订单信息才能安排送货；又如我们必须将您的订单信息与第三方商家共享来实现您向其购买商品或服务的需求，并使其完成后续的售后服务。</span></p>
            <p class="text-item"><span>我们会采用符合业界标准的安全防护措施来防止您的个人信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我们努力使用各种合理的制度、技术、程序以及物理层面的措施来保护您的个人信息不被未经授权的访问、篡改、披露或破坏，包括但不限于SSL传输加密技术、信息存储加密技术、数据中心的访问权限控制等技术或措施。</span></p>
            <p class="text-item">您可以取消或删除订单来删除您的订单信息，<span>但这样可能导致我们无法准确判断您的购物情况而难以提供相应的售后服务。</span>关于我们对于您个人信息的收集、使用、共享的详尽方式以及我们所能提供的个人信息安全技术措施请您查看<span class="tag" @click="handleTo">《甲子隐私政策》</span></p>
        </div>
    </div>
</template>
<script>
export default {
    name:'orderSharing',
    data() {
        return {
          
        }
    },
    methods:{
       handleTo() {
           this.$router.push({
               name:'privacyPolicy'
           })
       }
    }
}
</script>
<style lang="scss" scoped>
.text-content {
    padding:10px;
    line-height: 1.5;
    font-size: 16px;
    .text-item {
        text-indent: 2rem;
        span {
            text-decoration:underline;
            font-weight: 600;
        }
        .tag {
            text-decoration:none;
            color:red;
        }
    }
}
</style>